import React from 'react';
import Tooltip from 'src/components/atoms/Tooltip';
import { Language } from 'src/store/language/languageStore.types';
import {
  useLabels,
  useLanguageStore,
  useProjectsOverviewStore,
} from 'src/StoreDataProvider';
import { AverageRatingProps } from './evaluation.types';

const Evaluation: (props: AverageRatingProps) => JSX.Element = ({
  averageRating,
  isOneProject,
}) => {
  const labels = useLabels();
  const lang = useLanguageStore();
  const browserLang = lang.language === 'EN' ? 'en-US' : 'de-DE';
  const isError = useProjectsOverviewStore();
  const { language } = useLanguageStore();
  const {
    overall,
    relevance,
    coherence,
    effectivity,
    efficiency,
    impact,
    sustainability,
  } = averageRating;
  return (
    <>
      <div className="evaluation parent_box">
        <div className="box_1">
          <h2 className="evaluationTitle">
            {labels.overallRating}{' '}
            {!isError.isError && overall !== null
              ? overall?.toLocaleString(browserLang, {
                  minimumFractionDigits: isOneProject ? 0 : 1,
                  maximumFractionDigits: 1,
                })
              : '-'}
          </h2>
        </div>
        <div className="box_2">
          <ul>
            <li data-cy="evaluation-relevance">
              <span className="evaluation">
                {!isError.isError && relevance !== null
                  ? relevance?.toLocaleString(browserLang, {
                      minimumFractionDigits: isOneProject ? 0 : 1,
                      maximumFractionDigits: 1,
                    })
                  : '-'}
              </span>
              {labels.relevance}
            </li>
            <li data-cy="evaluation-coherence">
              <span className="evaluation">
                {!isError.isError && coherence !== null
                  ? coherence?.toLocaleString(browserLang, {
                      minimumFractionDigits: isOneProject ? 0 : 1,
                      maximumFractionDigits: 1,
                    })
                  : '-'}
              </span>
              {labels.coherence}{' '}
              <Tooltip tooltipText={labels.tooltipCoherence} />
            </li>
            <li data-cy="evaluation-effectivity">
              <span className="evaluation">
                {!isError.isError && effectivity !== null
                  ? effectivity?.toLocaleString(browserLang, {
                      minimumFractionDigits: isOneProject ? 0 : 1,
                      maximumFractionDigits: 1,
                    })
                  : '-'}
              </span>
              {labels.effectiveness}
            </li>
            <li data-cy="evaluation-efficiency">
              <span className="evaluation">
                {!isError.isError && efficiency !== null
                  ? efficiency?.toLocaleString(browserLang, {
                      minimumFractionDigits: isOneProject ? 0 : 1,
                      maximumFractionDigits: 1,
                    })
                  : '-'}
              </span>
              {labels.efficiency}
            </li>
            <li data-cy="evaluation-impact">
              <span className="evaluation">
                {!isError.isError && impact !== null
                  ? impact?.toLocaleString(browserLang, {
                      minimumFractionDigits: isOneProject ? 0 : 1,
                      maximumFractionDigits: 1,
                    })
                  : '-'}
              </span>
              {labels.impact}
            </li>
            <li data-cy="evaluation-sustainability">
              <span className="evaluation">
                {!isError.isError && sustainability !== null
                  ? sustainability?.toLocaleString(browserLang, {
                      minimumFractionDigits: isOneProject ? 0 : 1,
                      maximumFractionDigits: 1,
                    })
                  : '-'}
              </span>
              {labels.sustainability}
            </li>
          </ul>
        </div>
      </div>
      <div className="e_info">
        <p>
          {labels.ratingProcessMoreInformationBeforeLink}
          <a
            data-cy="rating-process-more-information-link"
            href={
              language === Language.DE
                ? 'https://www.kfw-entwicklungsbank.de/Internationale-Finanzierung/KfW-Entwicklungsbank/Evaluierungen/Bewertungskriterien/'
                : 'https://www.kfw-entwicklungsbank.de/International-financing/KfW-Development-Bank/Evaluations/Evaluation-criteria/'
            }
            target="_blank"
            rel="noreferrer"
            aria-label={
              labels.ratingProcessMoreInformationBeforeLink +
              labels.ratingProcessMoreInformationOnLink +
              labels.ratingProcessMoreInformationAfterLink
            }
          >
            {labels.ratingProcessMoreInformationOnLink}
          </a>
          {labels.ratingProcessMoreInformationAfterLink}
        </p>
      </div>
    </>
  );
};

export default Evaluation;
